import * as React from "react";
/**
 * Context to provide the store subscriber to the components
 * This needs to be declared as "| null" to decouple the instantiation from the context
 */ export const StoreSubscriptionManagerContext = React.createContext(null);
